module.exports = __webpack_public_path__ + "img/الحدود الشمالية.56f271c9.svg";